import Vue from 'vue';
import router from './router'
import index from './components/index.vue';
import 'animate.css';
import '../src/assets/reset.css';
import 'wowjs/css/libs/animate.css'
import wow from 'wowjs'
import {VueJsonp} from 'vue-jsonp'
import axios from "axios";

Vue.prototype.$axios = axios
Vue.use(VueJsonp)
Vue.prototype.$wow = wow

new Vue({
  el: '#app',
  router,
  render: h => h(index)
});
